import React from "react";
import SentimentVeryDissatisfiedIcon from "@material-ui/icons/SentimentVeryDissatisfied";
import "./EmptyCart.css";
const EmptyCart = () => {
  return (
    <React.Fragment>
      <div className="empty-cart d-flex justify-content-center align-content-center py-3">
        <SentimentVeryDissatisfiedIcon
          style={{ fontSize: "5rem" }}
          className="text-warning"
        />
      </div>
      <div className="empty-cart-content d-flex align-content-center justify-content-center text-center text-secondary">
        You have no items added to cart. <br />
        Browse, shop and add items to cart.
      </div>
    </React.Fragment>
  );
};

export default EmptyCart;
